import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from 'react-router-dom';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { api } from "../../Constant";
import axios from 'axios';
import Popup from '../RegisterScreen/Popup';
import emptywishlist from "../../assets/images/empty-wishlist.png"
import lovebg from "../../assets/images/love-bg.png";

const Wishlist = ({ onCartUpdate }) => {
    const params = useParams();
    const [products, setProducts] = useState([]);
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [username, setUsername] = useState("");
    const [type, setType] = useState('');
    const [userid, setUserid] = useState("");

    useEffect(() => {
        axios.post(api + `wishlist`, { user_id: userid })
            .then((response) => {
                if (response.data.success === "true") {
                    setProducts(response.data.product); 
                } else {
                    console.log('No products found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, [userid]);

    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        const storedUserid = localStorage.getItem('userId');
        setUsername(storedUsername || "");
        setUserid(storedUserid);
    }, []);

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const addCartclick = (product_id) => {
        if (!username) {
            setPopupMessage("Please log in to add items to the cart.");
            setType('error');
            setPopupVisible(true);
            return;
        }
        axios.post(api + "add_cart", {
            user_id: userid,
            product_id: product_id,
        })
            .then((response) => {
                if (response.data.success === "true") {
                    setPopupMessage("Cart added successfully!");
                    setType('success');
                    onCartUpdate();
                    removeWishlist(product_id);
                } else {
                    setPopupMessage("Failed to add to cart");
                    setType('error');
                }
                setPopupVisible(true);
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || "An error occurred while adding to cart.";
                setPopupMessage(errorMessage);
                setType("error");
                setPopupVisible(true);
            });
    };

    const removeWishlist = (product_id) => {
        axios.post(api + "remove_wishlist", {
            product_id: product_id,
            user_id: userid,
        })
            .then((response) => {
                if (response.data.success === "true") {
                    setProducts((prevCart) => prevCart.filter(item => item.product_id !== product_id));
                } else {
                    setPopupMessage("Failed to remove product from wishlist.");
                    setType("error");
                    setPopupVisible(true);
                }
            })
            .catch((error) => {
                setPopupMessage("An error occurred while removing the product from the wishlist.");
                setType("error");
                setPopupVisible(true);
            });
    };


    

    const navigate = useNavigate();

    const productdetailmove = (product_id) => {
        navigate(`/product-detail/${product_id}`);
    };

    const navigatehome = () => {
        navigate("/")
      }
    return (
        <>
            <div className="caytegory-bg pt-5 pb-5">
                <div className="container">
                    {products.length === 0 ? (
                        <div className="row cart-empty-padding">
              <div className="col-lg-12 cart-empty">
                <img src={emptywishlist} alt='emptywishlist'/>
                <h2>Your Wishlist is <span>Empty !</span></h2>
                <p>Explore more and more to Your list</p>
                <button onClick={navigatehome}>Countinue Shoping</button>
              </div>
            </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-12 category-title">
                                <h1>WishList</h1>
                            </div>
                            <div className="row category-main-top">
                              
{products.map((item) => (
    <div key={item.product_id} className="col-lg-3 col-sm-6 wishlistcategory maincategory">
        <div
            className="category-card"
            style={{
                backgroundImage: `url(${lovebg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: '10px',
                padding: '15px',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <img
                src={item.product_image}
                alt="imge1"
                style={{
                    width: '100%',
                    borderRadius: '10px',
                    objectFit: 'cover',
                }}
            />

            <div
                className="wishlist-cancel"
                onClick={() => removeWishlist(item.product_id)}
            >
                <FontAwesomeIcon icon={faXmark} />
            </div>
        </div>

        <div className="category-cardbottom">
            <p>{item.name}</p>
            {/* <h6>
                ₹ {item.discount_price}
                <span
                    style={{
                        textDecoration: 'line-through',
                        marginLeft: '10px',
                        color: 'gray',
                        fontSize: '14px',
                    }}
                >
                    ₹ {item.price}
                </span>
            </h6> */}

            <h6>
    ₹ {item.discount_price !== "0" ? item.discount_price : item.price}

    {item.discount_price !== "0" && (
        <span
            style={{
                textDecoration: 'line-through',
                marginLeft: '10px',
                color: 'gray',
                fontSize: '14px',
            }}
        >
            ₹ {item.price}
        </span>
    )}
</h6>

        </div>

        <div
            className="category-cardbottomone"
            onClick={() => productdetailmove(item.product_id)}
        >
            <a>Shop Now</a>
        </div>
    </div>
))}

                            </div>
                        </div>
                    )}
                    {popupVisible && (
                        <Popup
                            message={popupMessage}
                            title={type === "error" ? "Error" : "Notice"}
                            type={type}
                            onClose={handleClosePopup}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default Wishlist;
